import { Box, Button, Grid } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { InputSelectFieldGrid, InputTextFieldGrid } from "../../components";
import LastSales from "../../components/sale/LastSales";
import { confirmAlert, errorAlert } from "../../helpers/alerts";
import { setDenominations, setOperators, setSegments, setSelectedProduct, setShowDetail, setUpdate } from "../../redux/slices/sale/airTimeSlice";
import { getExtraDenominationByDenominationService } from "../../services/admin/extraDenominationService";
import { doStoreSale, sendTiketByEmail } from "../../services/sale/servipagosService";
import xml from "../../helpers/xml";
import { hideEmail, randomNumber, validateEmptyFields } from "../../helpers/util";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getBagDenominationsService, getBagOperatorService, getBagProductsService, getBagSegmentService, getBagService } from "../../services/client/bagService";
import Swal from "sweetalert2";
import { setSession } from "../../redux/slices/sessionSlice";
import DialogModal from "components/modal/DialogModal";
import { ArrowDownward, ArrowUpward, Cancel, CheckCircle } from "@mui/icons-material";
import ProductDetailSale from "components/sale/ProductDetailSale";
import Images from "assets/images";
import theme from "config/theme";

const AirTimeSaleScreen = () => {
  const dispatch = useDispatch();
  const { bags, sale: salepointId, updateBalance, email, password } = useSelector(store => store.session);
  const balance_bag = bags.find(bag => bag.type === 'TAE');
  const {
    showDetail,
    operators,
    segments,
    denominations,
  } = useSelector(store => store.airTimeSale);
  const { control, handleSubmit, setValue, watch, reset } = useForm();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false)
  // const [loadingSegments, setLoadingSegments] = useState(false);
  // const [loadingDenominations, setLoadingDenominations] = useState(false);
  const { operator, segment, denomination } = watch();
  const [bag, setBag] = useState({})
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });
  // const [showDetail, setShowDetail] = useState(false)

  useEffect(() => {
    getBagService(balance_bag.id).then(({ username, password, storeId }) => {
      setBag({ username, password, storeId })
    }).catch((e) => console.error(e))
    dispatch(setSelectedProduct(null));
    // eslint-disable-next-line
  }, [])
  // dispatch(setOperators([]));

  useEffect(() => {
    const data = watch();
    let disable = validateEmptyFields(data, {});
    if (!disable) {
      if (data.phone !== data.confirmPhone)
        disable = true;
    }
    setDisabled(disable);
    // eslint-disable-next-line
  }, [watch()]);

  useEffect(() => {
    setLoadingProducts(true)
    getBagProductsService(balance_bag.id, 'operadoras')
      .then((operadoras) => dispatch(setOperators(operadoras)))
      .finally(() => setLoadingProducts(false))
    getBagProductsService(balance_bag.id, 'segmentos')
      .then((segmentos) => dispatch(setSegments(segmentos)))
    getBagProductsService(balance_bag.id, 'denominaciones')
      .then((denominaciones) => dispatch(setDenominations(denominaciones)))
    // getBagOperatorService(balance_bag.id)
    //   .then((response) => dispatch(setOperators(response.filter((item) => item.commerce).map((item) => ({ ...item, id: item._id })))))
    //   .catch((error) => errorAlert(error));
    return () => {
      dispatch(setOperators([]));
      dispatch(setSegments([]));
      dispatch(setDenominations([]));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (operator) {
      const tempOperator = operators.find(({ id }) => operator === id);
      dispatch(setSelectedProduct({ image: tempOperator.fd }));
      if (segments.filter(s => s.idOperator === operator).length === 1)
        setValue('segment', segments.find(s => s.idOperator === operator).id);
      // setLoadingSegments(true)
      // getBagSegmentService(balance_bag.id, operator, false)
      //   .then((result) => {
      //     dispatch(setSegments(result.map((item) => ({ ...item, id: item._id }))))
      //     if (result.length === 1)
      //       setValue('segment', result[0]._id)

      //   })
      //   .catch((e) => errorAlert(e))
      //   .finally(() => setLoadingSegments(false))
    }
    // eslint-disable-next-line
  }, [operator]);

  // useEffect(() => {
  //   if (segments.length !== 0 && segment) {
  //     // const tempSegment = segments.find(({ id }) => segment === id);
  //     // dispatch(setSelectedProduct({ image: tempSegment.fd, type: tempSegment.name }));
  //     // setLoadingDenominations(true)
  //     // getBagDenominationsService(balance_bag.id, operator, false, segment)
  //     //   .then((result) => dispatch(setDenominations(result.map((item) => ({ ...item, id: item._id })))))
  //     //   .catch((e) => errorAlert(e))
  //     //   .finally(() => setLoadingDenominations(false))
  //   }
  //   // eslint-disable-next-line
  // }, [segment, segments]);

  useEffect(() => {
    if (denominations.length !== 0 && denomination) {
      const tempOperator = operators.find(({ id }) => operator === id);
      const tempSegment = segments.find(({ id }) => segment === id);
      const product = denominations.find(({ id }) => id === denomination);
      getExtraDenominationByDenominationService(denomination)
        .then((extraDenomination) => dispatch(setSelectedProduct({
          ...product,
          extraDenomination,
          image: tempOperator.fd,
          type: tempSegment.name
        })))
        .catch((e) => errorAlert(e))
    }
    // eslint-disable-next-line
  }, [denomination, denominations]);



  const submit = async ({ denomination, phone, confirmPhone }) => {
    setLoading(true)
    try {
      const selected_denomination = denominations.find(({ id }) => id === denomination);
      const selected_segment = segments.find(({ id }) => id === segment);
      const selected_operator = operators.find(({ id }) => id === operator);
      const externalTrace = randomNumber(100000, 999999);
      const sale = {
        username: email,
        password,
        storeId: bag.storeId,
        provider: selected_segment.carrierId,
        amount: selected_denomination.denomination,
        number: phone,
        productDetail: selected_segment.code,
        externalTrace,
        salepointId
      }
      let xmlResponse = await doStoreSale(sale);
      xmlResponse = new xml(xmlResponse)
      const error = xmlResponse.getElementValue("phon:ProviderResponseCode");
      if (error !== '00') {
        let message = xmlResponse.getElementValue("phon:ProviderResponseMessage");
        message = message == 'InsufficientBalance' ? 'No cuenta con suficiente saldo para esta operación' : message;
        errorAlert({ message: message || "Error" })
      } else {
        reset({ operator: '', segment: '', denomination: '' });
        dispatch(setSelectedProduct(null));
        dispatch(setSession({ updateBalance: updateBalance + 1 }));
        setDialog({
          open: true,
          title: "Recarga Éxitosa",
          body:
            <div>
              <CheckCircle color="success" sx={{ width: 60, height: 60 }} />
              <h3>Número de autorización {xmlResponse.getElementValue("phon:AuthCode")}</h3>
              <div>Teléfono: {phone}</div>
              <div>Compañia: {selected_operator.name}</div>
              <div>Tipo: {selected_segment.name}</div>
              <div>Monto: {sale.amount}</div>
              <div>Fecha: {moment().format('DD/MM/YYYY HH:mm:ss')}</div>
            </div>,
          closeText: "Continuar",
          successText: "Descargar",
          onClose: () => setDialog({ open: false }),
          onSuccess: () => {
            document.body.appendChild(document.createElement('div')).innerHTML = `
            <div id="ticket-print">
              <div class="title">Comprobante de compra</div>
              <div class="text">Número de autorización ${xmlResponse.getElementValue("phon:AuthCode")}</div>
              <div class="text">Teléfono: ${phone}</div>
              <div class="text">Compañia: ${selected_operator.name}</div>
              <div class="text">Tipo: ${selected_segment.name}</div>
              <div class="text">Monto: ${sale.amount}</div>
              <div class="text">Fecha: ${moment().format('DD/MM/YYYY HH:mm:ss')}</div>
            </div>
          `;
            html2canvas(document.querySelector('#ticket-print')).then(
              canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF({
                  format: [80, 100],
                  unit: "mm"
                });
                pdf.addImage(imgData, 'PNG', 10, 20, 60, 60);
                pdf.save('comprobante.pdf');
                document.querySelector('#ticket-print').remove();
              }
            );
          },
          additionalButton: (
            <Button
              color='info'
              onClick={() => {
                setDialog({ open: false })
                Swal.fire({
                  title: 'Ingresa el correo electrónico',
                  input: 'text',
                  inputAttributes: {
                    autocapitalize: 'off'
                  },
                  showCancelButton: true,
                  confirmButtonText: 'Enviar',
                  showLoaderOnConfirm: true,
                  cancelButtonColor: "#ED3726",
                  preConfirm: (email) => {
                    return sendTiketByEmail(email, {
                      auth: xmlResponse.getElementValue("phon:AuthCode"),
                      phone: phone,
                      operator: selected_operator.name,
                      segment: selected_segment.name,
                      amount: sale.amount,
                      date: moment().format('DD/MM/YYYY HH:mm:ss'),
                    }).then(() => {
                      confirmAlert({
                        icon: "success",
                        title: "Enviado",
                        text: `Se ha enviado el ticket de la transacción al correo electrónico ${hideEmail(email)}`,
                        showCancelButton: false,
                      })
                    }).catch((error) => {
                      Swal.showValidationMessage(error)
                    })
                  },
                  allowOutsideClick: () => !Swal.isLoading()
                })
              }}
              variant="contained"
            >
              Enviar
            </Button>
          )
        })
      }
    } catch (e) {
      console.error(e);
      if (e.code === 501)
        setDialog({
          open: true,
          title: "Recarga Denegada",
          body:
            <div>
              <Cancel color="error" sx={{ width: 60, height: 60 }} />
              <div>{e.message}</div>
            </div>,
          onClose: () => setDialog({ open: false })
        })
      else
        setDialog({
          open: true,
          title: "Recarga Denegada",
          body:
            <div>
              <Cancel color="error" sx={{ width: 60, height: 60 }} />
              <div>
                Ha ocurrido un error al realizar la recarga, Vuelve a intentarlo y si el error persiste contacta a tu administrador.
              </div>
            </div>,
          onClose: () => setDialog({ open: false })
        })
    } finally {
      setLoading(false)
      dispatch(setUpdate(moment().unix()))
    }
  }

  return (
    <>
      {
        showDetail ? <Box mt={2} mb={2}>
          <Box>
            <Box backgroundColor='#FFFFFF' p={2}>
              <Grid container item spacing={4} >
                <InputSelectFieldGrid
                  name={"operator"}
                  xs={4}
                  control={control}
                  required={"Debes seleccionar una operadora"}
                  label={"Compañia"}
                  data={operators}
                  loading={loadingProducts}
                  sx={{ height: '48px' }}
                  // size={'large'}
                  formatter={(data) =>
                    data?.map(({ id, name }) => ({ id: id, name: name }))
                  }
                  onSelect={() => {
                    setValue('segment', '')
                    setValue('denomination', '')
                    dispatch(setSelectedProduct(null));
                  }}
                />
                <InputSelectFieldGrid
                  xs={4}
                  control={control}
                  name={"segment"}
                  required={"Debes seleccionar un segmento"}
                  label={"Tipo"}
                  data={segments.filter(s => s.idOperator === operator)}
                  // loading={loadingSegments}
                  disabled={operator == null}
                  formatter={(data) =>
                    data?.map(({ id, name }) => ({ id: id, name: name }))
                  }
                  onSelect={() => {
                    setValue('denomination', '')
                    dispatch(setSelectedProduct(null));
                  }}
                />
                <InputSelectFieldGrid
                  xs={4}
                  control={control}
                  name={"denomination"}
                  label={"Monto"}
                  required={"Debes seleccionar un monto"}
                  data={denominations.filter(s => s.idSegment === segment)}
                  // loading={loadingDenominations}
                  disabled={!segment}
                  formatter={(data) =>
                    data.map((item) => ({ id: item.id, name: item.denomination }))
                  }
                />
                <InputTextFieldGrid
                  xs={4}
                  control={control}
                  name={"phone"}
                  placeholder={"Número celular"}
                  rules={{
                    required: { value: true, message: "Debes agregar el número celular" },
                    maxLength: { value: 10, message: "El número celular es de máximo 10 dígitos" },
                    pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: "Número celular inválido" },
                  }}
                  inputType={'tel'}
                  inputProps={{
                    type: 'tel',
                    maxLength: 10
                  }}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: theme.backgroundColor,
                      borderRadius: '8px',
                      color: theme.contrastColor,
                      fontWeight: 'bold',
                      fontSize: '35px',
                      padding: '20px',
                      borderBottom: ' 2px solid ' + theme.contrastColor,
                    }
                  }}
                />
                <InputTextFieldGrid
                  xs={4}
                  name={"confirmPhone"}
                  control={control}
                  placeholder={"Confirmar número"}
                  rules={{
                    required: { value: true, message: "Debes agregar el número celular" },
                    maxLength: { value: 10, message: "El número celular es de máximo 10 dígitos" },
                    pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: "Número celular inválido" },
                  }}
                  inputType={'tel'}
                  inputProps={{
                    type: 'tel',
                    maxLength: 10
                  }}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: theme.backgroundColor,
                      borderRadius: '8px',
                      color: theme.contrastColor,
                      fontWeight: 'bold',
                      fontSize: '35px',
                      padding: '20px',
                      borderBottom: ' 2px solid ' + theme.contrastColor,
                    }
                  }}
                />
                <Grid
                  container
                  item
                  xs={4}
                  justifyContent={"center"}
                  alignContent={"center"}
                  flexDirection={"row"}
                  gap={4}
                >
                  <LoadingButton
                    loading={loading}
                    sx={{
                      flex: 1,
                      display: 'flex',
                      backgroundColor: theme.contrastColor,
                      borderRadius: 25,
                      color: "white",
                      // padding: '4px 32px',
                      boxShadow: 'none',
                      fontWeight: "bold",
                      fontSize: '18px',
                      textTransform: 'none',
                      '&:disabled': {
                        color: "white",
                      }
                    }}
                    onClick={handleSubmit(submit)}
                    disabled={disabled}
                    variant="contained"
                  >
                    Recargar
                  </LoadingButton>
                  <Button
                    sx={{

                      // width: '100%',
                      fontWeight: "bold",
                      backgroundColor: '#FFFFFF',
                      boxShadow: 'none',
                      border: '2px solid ' + theme.contrastColor,
                      borderRadius: 8,
                      color: theme.contrastColor,
                      fontSize: '18px',
                      // padding: '5px 25px',
                      textTransform: 'none',
                    }}
                    endIcon={<ArrowDownward />}
                    onClick={() => dispatch(setShowDetail(!showDetail))}
                  >
                    Ocultar detalles
                  </Button>
                </Grid>
              </Grid>
            </Box>
            <ProductDetailSale />
            <LastSales />
          </Box>
        </Box> : <Box mt={2}>
          <Box border={'2px solid #041C3F'} borderRadius={4} padding={4} sx={{
            backgroundImage: `url('${Images[theme.code].logo_gray}')`,
            backgroundSize: '100px',
          }}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
            >
              <Grid container item rowSpacing={4} maxWidth={'30vw'} backgroundColor={theme.backgroundColor} my={-4} p={2}>
                <InputSelectFieldGrid
                  name={"operator"}
                  xs={12}
                  control={control}
                  required={"Debes seleccionar una operadora"}
                  label={"Compañia"}
                  data={operators}
                  loading={loadingProducts}
                  sx={{ height: '48px' }}
                  // size={'large'}
                  formatter={(data) =>
                    data?.map(({ id, name }) => ({ id: id, name: name }))
                  }
                  onSelect={() => {
                    setValue('segment', '')
                    setValue('denomination', '')
                    dispatch(setSelectedProduct(null));
                  }}
                />
                <InputSelectFieldGrid
                  xs={12}
                  control={control}
                  name={"segment"}
                  required={"Debes seleccionar un segmento"}
                  label={"Tipo"}
                  data={segments.filter(s => s.idOperator === operator)}
                  // loading={loadingSegments}
                  disabled={operator == null}
                  formatter={(data) =>
                    data?.map(({ id, name }) => ({ id: id, name: name }))
                  }
                  onSelect={() => {
                    setValue('denomination', '')
                    dispatch(setSelectedProduct(null));
                  }}
                />
                <InputSelectFieldGrid
                  xs={12}
                  control={control}
                  name={"denomination"}
                  label={"Monto"}
                  required={"Debes seleccionar un monto"}
                  data={denominations.filter(s => s.idSegment === segment)}
                  // loading={loadingDenominations}
                  disabled={!segment}
                  formatter={(data) =>
                    data.map((item) => ({ id: item.id, name: item.denomination }))
                  }
                />
                <InputTextFieldGrid
                  xs={12}
                  control={control}
                  name={"phone"}
                  placeholder={"Número celular"}
                  rules={{
                    required: { value: true, message: "Debes agregar el número celular" },
                    maxLength: { value: 10, message: "El número celular es de máximo 10 dígitos" },
                    pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: "Número celular inválido" },
                  }}
                  inputType={'tel'}
                  inputProps={{
                    type: 'tel',
                    maxLength: 10
                  }}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: '#FFFFFF',
                      borderRadius: '8px',
                      textAlign: 'center',
                      color: theme.contrastColor,
                      fontWeight: 'bold',
                      fontSize: '40px',
                      padding: '20px 0px',
                      borderBottom: ' 2px solid ' + theme.contrastColor,
                    }
                  }}
                />
                <InputTextFieldGrid
                  xs={12}
                  name={"confirmPhone"}
                  control={control}
                  placeholder={"Confirmar número"}
                  rules={{
                    required: { value: true, message: "Debes agregar el número celular" },
                    maxLength: { value: 10, message: "El número celular es de máximo 10 dígitos" },
                    pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: "Número celular inválido" },
                  }}
                  inputType={'tel'}
                  inputProps={{
                    type: 'tel',
                    maxLength: 10
                  }}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: '#FFFFFF',
                      borderRadius: '8px',
                      textAlign: 'center',
                      color: theme.contrastColor,
                      fontWeight: 'bold',
                      fontSize: '40px',
                      padding: '20px 0px',
                      borderBottom: ' 2px solid ' + theme.contrastColor,
                    }
                  }}
                />
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={"center"}
                >
                  <LoadingButton
                    loading={loading}
                    sx={{
                      backgroundColor: theme.contrastColor,
                      borderRadius: 25,
                      color: "white",
                      padding: '12px 64px',
                      boxShadow: 'none',
                      fontWeight: "bold",
                      fontSize: '32px',
                      textTransform: 'none',
                      '&:disabled': {
                        color: "white",
                      }
                    }}
                    onClick={handleSubmit(submit)}
                    disabled={disabled}
                    variant="contained"
                  >
                    Recargar
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box mt={4} mb={2} display="flex" justifyContent="center">
            <Button
              sx={{
                fontWeight: "bold",
                backgroundColor: '#FFFFFF',
                boxShadow: 'none',
                border: '2px solid ' + theme.contrastColor,
                borderRadius: 8,
                color: theme.contrastColor,
                padding: '5px 15px',
                textTransform: 'none',
              }}
              endIcon={showDetail ? <ArrowUpward /> : <ArrowDownward />}
              onClick={() => dispatch(setShowDetail(!showDetail))}
            >
              {showDetail ? 'Ocultar detalles' : 'Ver Detalles'}
            </Button>
          </Box>
        </Box >
      }
      <DialogModal {...dialog} />
    </>
  );
};

export default AirTimeSaleScreen;
